import { ProfileImprovement } from "@/@types";

export const useProfileImprovement = (obj: ProfileImprovement) => {
  if (!obj) return { percentage: 0, concludedCount: 0, totalCount: 0 };
  const values = Object.values(obj);
  const concludedCount = values.filter((value) => value === true).length;
  const totalCount = values.length;
  const percentage = (concludedCount / totalCount) * 100;
  return {
    percentage,
    concludedCount,
    totalCount,
  };
};
